// @flow strict

import { type ContentfulNode } from '@mondough/contentful'
import { subtitleNodeName } from '@mondough/contentful/src/richTextDecorators'
import * as React from 'react'
import { useState } from 'react'
import { SectionThemes, SectionWrapper } from '../../SectionWrapper'

import APR19_RATES from '../data/slider-values-ear19.json'
import APR29_RATES from '../data/slider-values-ear29.json'
import APR39_RATES from '../data/slider-values-ear39.json'
import APR19_UNARRANGED from '../data/slider-values-ear19-unarranged.json'
import APR29_UNARRANGED from '../data/slider-values-ear29-unarranged.json'
import APR39_UNARRANGED from '../data/slider-values-ear39-unarranged.json'

import styles from './OverdraftFeeCalculator.module.scss'
import OverdraftFeePicker from './OverdraftFeePicker'
import OverdraftSliderGroup from './OverdraftSliderGroup'
import { RATE_APR_39 } from './constants'
import OverdraftFeeTotal from './OverdraftFeeTotal'
import { defaultSubtitleSection } from '../../../contentful/defaultThemeComponents'

type Overdraft = {| amount: number, days: number |}

export const OverdraftFeeCalculator = (props: {
  subtitle?: ContentfulNode,
}) => {
  const [arranged, setArranged] = useState<Overdraft>({ amount: 0, days: 1 })
  const [unarranged, setUnarranged] = useState<Overdraft>({
    amount: 0,
    days: 1,
  })
  const [rate, setRate] = useState(RATE_APR_39)

  function onRateChange(event) {
    return setRate(event.target.value)
  }

  return (
    <>
      <SectionWrapper
        theme={SectionThemes.GREY}
        contentClassName={styles.baseContent}
      >
        <form className={styles.box} id="overdraftCalculator">
          <div className={styles.sliders}>
            <h3 className={styles.subtitle}>Overdraft cost calculator</h3>
            <div className={styles.sliderBox}>
              <h4 className={styles.subsubtitle}>Arranged</h4>
              <OverdraftSliderGroup
                overdraft={arranged}
                onChange={newValues => setArranged(newValues)}
                id="arranged"
              />
            </div>
            <div className={styles.sliderBox}>
              <h4 className={styles.subsubtitle}>Unarranged</h4>
              <OverdraftSliderGroup
                overdraft={unarranged}
                onChange={newValues => setUnarranged(newValues)}
                id="unarranged"
              />
            </div>
          </div>
          <OverdraftFeePicker
            arranged={arranged}
            unarranged={unarranged}
            onRateChange={onRateChange}
            rate={rate}
          />
          <div className={styles.total}>
            <OverdraftFeeTotal
              arranged={arranged}
              unarranged={unarranged}
              rate={rate}
              data={{
                unarranged: {
                  APR19: APR19_UNARRANGED,
                  APR29: APR29_UNARRANGED,
                  APR39: APR39_UNARRANGED,
                },
                arranged: {
                  APR19: APR19_RATES,
                  APR29: APR29_RATES,
                  APR39: APR39_RATES,
                },
              }}
            />
            <p>
              <strong>Total cost</strong>
            </p>
          </div>
        </form>
        {(props.subtitle &&
          defaultSubtitleSection(props.subtitle, { leftAlign: true })) ||
          null}
      </SectionWrapper>
    </>
  )
}

export function renderOverdraftFeeCalculator(node: ContentfulNode) {
  return <OverdraftFeeCalculator subtitle={node[subtitleNodeName]} />
}
